import { COMMON } from '../../Enum/EndPoint/CommonEndpoint';

export const DIVISION_URL = Object.freeze({
  COUNT: COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.COUNT,
  LIST: function list(page, limit, order) {
    return COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.LIST(page, limit, order);
  },
  REJECT: COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.REJECT,
  DETAIL: COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.INDEX,
  DETAIL_EXISTING: COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.EXISTING,
  SEARCH: COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.SEARCH,
  COUNT_SEARCH: COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.SEARCH + COMMON.COUNT,
  MAPPING_APPROVE: COMMON.MAPPING + COMMON.MAPPING_TYPE.DIVISION + COMMON.APPROVE,
});
